export default "__VITE_ASSET__lil_544h__"